var categoryFAQ = $('.page-template-page-faq').find('.category');
categoryFAQ.find('.question').click(function(){
    console.log(this);
});